module.exports = __webpack_public_path__ + "img/login.ecf659bc.jpg";